import { render, staticRenderFns } from "./OnboardingName.vue?vue&type=template&id=55ccc3e9&"
import script from "./OnboardingName.vue?vue&type=script&lang=js&"
export * from "./OnboardingName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports